import React from 'react'
import { Box, Toolbar, Typography } from "@mui/material";
import Disclaimertext from '../Component/Disclaimertext';
import Footer from '../Component/Footer';
import { useLanguage } from '../context/LanguageContext';
import Header from "../Component/header";
import DesktopFooter from "../Component/Desktopfooter";
const Disclaimer = () => {
  const { t } = useLanguage();
  return (
    <>
      <div className='text-Wrapper'>
<Header/>
        <Box>
          <Toolbar>
            <Disclaimertext />
          </Toolbar>
        </Box>
      </div>
       <DesktopFooter/>
      <Footer />
    </>
  )
}

export default Disclaimer



